module.exports = __webpack_public_path__ + "media/images/usat-logo-white-2a2168050afba7db97aec2e3aee063eb.png";